import {getKindnessIndex} from '@/api'

const actions = {
	async getKindnessData({commit}){
		let res = await getKindnessIndex()
			commit('SAVE_KIDNESS_DATA',res)
	}
}

const mutations = {
	SAVE_KIDNESS_DATA(state,data){
		state.chosen = data.data.chosen
		state.kindness = data.data.kindness
		state.nav = data.data.nav
	}
}

const state = {
	nav:[],
	kindness:[],
	chosen:[],
}

const getters = {
	chosenList_one(state){
        return state.chosen.filter((item,i)=> i%2==0)
    },
	chosenList_two(state){
        return state.chosen.filter((item,i)=> i%2!=0)
    },
	
}

export default {
	actions,
	mutations,
	state,
	getters
}